import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const IPaneCompositePartService = ( createDecorator('paneCompositePartService'));
export { IPaneCompositePartService };
